import Checkbox from "../../../../Atoms/Checkbox";
import styles from "./MarketingSubscriptionCheckbox.module.css";

interface Props {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

export default function MarketingSubscriptionCheckbox({
  checked = false,
  onChange,
}: Props) {
  function handleClick() {
    onChange(!checked);
  }

  return (
    <label
      className={styles.MarketingSubscriptionCheckbox}
      onClick={handleClick}
    >
      <span className={styles.MarketingSubscriptionCheckboxCheckbox}>
        <Checkbox checked={checked} />
      </span>{" "}
      I want to receive promotional emails from MagicalTrip
    </label>
  );
}
